enum EFacetNameMapping {
    //for multimedia core
    types = 'attached files',
}

export default EFacetNameMapping;